import { fetchAllAllowedClients } from 'Services/ServiceProviderManagement/Features/AllowedClient/allowedClientSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { useEffect } from 'react'

interface UseAllowedClientsProps {
  excludeManagerClient?: boolean
}

function useAllowedClients({ excludeManagerClient = false }: UseAllowedClientsProps = {}) {
  const dispatch = useAppDispatch()

  const { allowedClients, allowedClientsLoading } = useTypedSelector(
    state => state.spmAllowedClient
  )

  useEffect(() => {
    dispatch(
      fetchAllAllowedClients(
        excludeManagerClient ? { exclude_manager_client: excludeManagerClient } : {}
      )
    )
  }, [])

  return {
    allowedClients,
    allowedClientsLoading
  }
}

export default useAllowedClients
